import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { interval, Subscription } from 'rxjs';

export interface ProgressBarSimulationData {
  label: string;
  min: number;
  max: number;
}

@Component({
  selector: 'ps-ui-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
})
export class ProgressBarComponent implements OnInit, OnDestroy {
  private _subscriptions: Subscription = new Subscription();

  @Input() currentProgress: number = 100; // should be in percentage
  @Input() height: number = 25; // should be in px
  @Input() showStripes: boolean = true; // for stripes please use bootstrap bg classes
  @Input() label: string = 'Loading, Please Wait ...';
  @Input() labelColour: string = 'white';
  @Input() animate: boolean = true;
  @Input() intervalValue: number = 100;
  @Input() simulate: boolean = false;
  @Input() threshold: number = 100;
  @Input() progressBarColor: string = '';
  @Input() showLabelAtTop: boolean = true;
  @Input() randomIncreament: boolean = false;
  @Input() showInfinityProgressBar: boolean = false;
  @Input() simulationData: ProgressBarSimulationData[] = [
    {
      label: 'Searching for Similar Data…',
      min: 0,
      max: 25,
    },
    {
      label: 'Analysing Repository…',
      min: 25,
      max: 50,
    },
    {
      label: 'Matching Metadata…',
      min: 50,
      max: 75,
    },
    {
      label: 'Finalizing Results…',
      min: 75,
      max: 100,
    },
    {
      label: 'Returning Results…',
      min: 100,
      max: 100,
    },
  ];

  public showSimilarProjectPogressBar: boolean = false;
  public progressBarLabel: string;

  ngOnInit(): void {
    if (this.simulate) {
      this.currentProgress = 0;
      this.simulateProgress();
    }
  }

  simulateProgress() {
    // Simulate the progress by incrementing every this.intervalValue ms
    this._subscriptions.add(
      interval(this.intervalValue).subscribe(() => {
        if (this.currentProgress < this.threshold) {
          // Cap progress at threshold while waiting
          this.currentProgress += this.getIncreamentValue();
          this.updateStatusMessage();
        }
      })
    );
  }

  getIncreamentValue() {
    return this.randomIncreament ? Math.random() * 5 : 1;
  }

  updateStatusMessage() {
    if (this.currentProgress === 100) {
      const finalLabel =
        this.simulationData[this.simulationData.length - 1].label;
      this.label = finalLabel;
      return;
    }

    this.simulationData.forEach((data) => {
      if (this.currentProgress >= data.min && this.currentProgress < data.max) {
        this.label = data.label;
      }
    });
  }

  ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }
}
